import gql from 'graphql-tag';
import React from 'react';
import { buildCheckoutClickEvent } from '../lib/checkoutTracking';
import {
  CheckoutCreditCardSummaryFields,
  CheckoutTrackingFields,
  core_apimessages_CheckoutPaymentMethod_Type as PaymentMethodType,
} from '../schemas/rql';
import CheckoutVerifyCardCVV from './checkout_verify_card_cvv';
import CreditCardBrandIcon from './credit_card_brand_icon';
import { CreditCardWalletClickInteraction } from '@reverbdotcom/commons/src/elog/mparticle_types';

type CreditCard = CheckoutCreditCardSummaryFields.CreditCard;

type Checkout = CheckoutTrackingFields.Fragment;

interface Props {
  creditCard: CreditCard;
  checkoutId?: string;
}

export default function CheckoutCreditCardSummary({ creditCard, checkoutId }: Props) {

  const checkout: Checkout = {
    id: checkoutId,
    paymentMethod: {
      type: PaymentMethodType.DIRECT_CHECKOUT,
    },
  };

  const trackEvent = buildCheckoutClickEvent(checkout);

  return (
    <div>
      <div className="d-flex">
        <div style={{ width: '5rem' }}>
          <CreditCardBrandIcon
            brand={creditCard.brand}
          />
        </div>
        <div className="pl-1">
          <div className="weight-bold">
            {creditCard.display.summary}
          </div>
          <div className="size-80">
            {creditCard.display.expirationDate}
          </div>
        </div>
      </div>
      <div>
        {creditCard.needsReverification &&
          <div className="mt-space">
            <CheckoutVerifyCardCVV
              creditCard={creditCard}
              trackEvent={() => trackEvent(CreditCardWalletClickInteraction.VerifyCVV)}
              hasRefetch
            />
          </div>
        }
      </div>
    </div>
  );
}

export const CheckoutCreditCardSummaryFragment = gql`
  fragment CheckoutCreditCardSummaryFields on Checkout {
    _id
    creditCard {
      needsReverification
      cardType
      brand {
        type
        name
      }
      display {
        summary
        expirationDate
      }
    }
  }
`;
